module.exports = __webpack_public_path__ + "static/contract-package-4-7572a5a6a2a24b1f1a78e1fd58015e98.pdf";